import React from "react";
import { Row, Col, Card, Tabs } from "antd";
import LogHoursHeader from "./Header/LogHoursHeader";
import LogHoursModal from "./Modal/LogHoursModal";
import WROHoursPanel from "./TabPanels/WROHoursPanel";
import SpecialProjectHoursPanel from "./TabPanels/SpecialProjectHoursPanel";

const { TabPane } = Tabs;

function LogHoursPage() {
  const [modalVisible, setModalVisible] = React.useState(false);

  function onAddEntryPress() {
    setModalVisible(true);
  }

  function onModalOk() {
    setModalVisible(false);
  }

  function onModalCancel() {
    setModalVisible(false);
  }

  return (
    <Row gutter={[0, 28]}>
      <Col span={24}>
        <LogHoursHeader onAddEntryPress={onAddEntryPress} />
      </Col>
      <Col span={24}>
        <Card>
          <Tabs defaultActiveKey="1">
            <TabPane tab="Receiving" key="1">
              <WROHoursPanel />
            </TabPane>

            <TabPane tab="Special Projects" key="2">
              <SpecialProjectHoursPanel />
            </TabPane>
          </Tabs>
        </Card>

        <LogHoursModal visible={modalVisible} onOkay={onModalOk} onCancel={onModalCancel} />
      </Col>
    </Row>
  );
}

export default LogHoursPage;
